import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Palette, FileText, Globe, Image as ImageIcon, Video, Radio } from 'lucide-react';
export function AdvertisingPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-102" data-mp="1plpto466ui9v">
      <Header data-id="element-103" data-mp="1ftshov7cvma3" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-104" data-mp="1ftad9baji1r3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="1fshdiua00cig">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-106" data-mp="1klkazdhwc63x">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-107" data-mp="16ratib854jkg" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-108" data-mp="1asmo6v5vfuzi">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-109" data-mp="wvzhw1s13sgx">
              TwiceBourne Advertising
            </h1>
            <p className="text-2xl text-slate-300" data-id="element-110" data-mp="11w3wfm9dmd4i">
              Your one-stop creative centre
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-111" data-mp="111ev0vvw7yfx">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-112" data-mp="113hhj5xu79fw">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-113" data-mp="1a2mfaa1kqyr0">
                <Palette className="w-7 h-7" data-id="element-114" data-mp="m9w6uasvqxlh" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-115" data-mp="ibyjzeml0nl9">
                Logo & Branding
              </h3>
              <p className="text-slate-400" data-id="element-116" data-mp="w3d27j8o0kr9">
                Crafting unique brand identities that stand out.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-117" data-mp="3l925tem8a8f">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-118" data-mp="1yoxd3ky1bz4i">
                <FileText className="w-7 h-7" data-id="element-119" data-mp="23ngztnkgdexx" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-120" data-mp="23lxlw3m9rfzb">
                Print Design
              </h3>
              <p className="text-slate-400" data-id="element-121" data-mp="2ddttc5a8wig7">
                Business cards, flyers, and physical marketing materials.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-122" data-mp="1frcvmyxlo2tx">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-123" data-mp="1pnzfbke6wnud">
                <Globe className="w-7 h-7" data-id="element-124" data-mp="1tqm1p5s3dgk6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-125" data-mp="313xl9fe2mtrd">Web Design</h3>
              <p className="text-slate-400" data-id="element-126" data-mp="354zm20nmzdvg">
                Beautiful, responsive websites tailored to your business.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-127" data-mp="tgcph4wzqk51">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-128" data-mp="koj2azmyib6h">
                <ImageIcon className="w-7 h-7" data-id="element-129" data-mp="fpg9qeo5xxfe" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-130" data-mp="aro6wplzcqwf">
                Graphic Design
              </h3>
              <p className="text-slate-400" data-id="element-131" data-mp="5r0ga51nyc2q">
                Custom graphics for social media and digital campaigns.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-132" data-mp="1sb4ui06r4lq">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-133" data-mp="1w3pvr24xna32">
                <Video className="w-7 h-7" data-id="element-134" data-mp="1r3k1rfb6xbht" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-135" data-mp="nvsd8oqj9zem">Video Ads</h3>
              <p className="text-slate-400" data-id="element-136" data-mp="sttxhczp44ro">
                Compelling video content that drives engagement.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-137" data-mp="evwyyb1oload">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-138" data-mp="52g5571jo96p">
                <Radio className="w-7 h-7" data-id="element-139" data-mp="9wspdjauhoji" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-140" data-mp="3s9qib697zh46">Radio Ads</h3>
              <p className="text-slate-400" data-id="element-141" data-mp="4emuoby0dwa">
                Professional audio production for radio broadcasting.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-142" data-mp="3n9cl6j95prkx" />
    </div>;
}